const des_confirmar_estimativa_de_matricula_por_escola = {
  path: "/des-confirmar-estimativa-de-matricula-por-escola",
  redirect: "/des-confirmar-estimativa-de-matricula-por-escola",
  meta: {
    breadCrumb:
      "Planejamento de Matrícula - Desconfirmar Estimativa de Matrícula por Escola",
  },
  children: [
    {
      path: "/des-confirmar-estimativa-de-matricula-por-escola",
      name: "des-confirmar-estimativa-de-matricula-por-escola",
      component: () =>
        import(
          "@/views/DesConfirmarEstimativaDeMatriculaPorEscola/DesConfirmarEstimativaDeMatriculaPorEscola.vue"
        ),
    },
  ],
};

export { des_confirmar_estimativa_de_matricula_por_escola };
